import { render, staticRenderFns } from "./blank_only_logo.vue?vue&type=template&id=1b18cb30&scoped=true&lang=pug&"
import script from "./blank_only_logo.vue?vue&type=script&lang=js&"
export * from "./blank_only_logo.vue?vue&type=script&lang=js&"
import style0 from "./blank_only_logo.vue?vue&type=style&index=0&id=1b18cb30&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b18cb30",
  null
  
)

export default component.exports